import { render, staticRenderFns } from "./buyerAuthInfo.vue?vue&type=template&id=07768d7a&"
import script from "./buyerAuthInfo.vue?vue&type=script&lang=js&"
export * from "./buyerAuthInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports